import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {ModuloComponent} from 'src/app/modulo/modulo.component';
import { ModuloService } from '../modulo/modulo.service';
import { AplicacionesService } from '../aplicaciones/aplicaciones.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { AccionesService } from './acciones.service';
import { MenuService } from '../editar-menu/menu.service';
import { EditarAccionComponent } from './editar-accion/editar-accion.component';
import { TablesService } from '../generico/tables/tables.service';


@Component({
  selector: 'app-acciones',
  templateUrl: './acciones.component.html',
  styleUrls: ['./acciones.component.scss']
})
export class AccionesComponent implements OnInit {
  accionesForm = this.fb.group({
    modulo: [null],
    tipo: [null],
  });

  modulos = [];
  tipo_opcion = [
    {'descripcion' : 'Menu', 'valor' : 1},
    {'descripcion' : 'Acciones', 'valor' : 2}
  ];
  menu = [];
  nombre_tabla = 'acciones-app-edit'
  ver_tree_menu = false;
  
  ver_tabla_acciones : boolean = false;
  recurso_acciones ='obtenerAcciones';
  columns_acciones = ['id','descripcion', 'ruta', 'estado', 'acciones'];
  target
  params = {};

  constructor(private fb: FormBuilder,
              private dialog: MatDialog,
              private mod_serv : ModuloService, 
              private app_serv : AplicacionesService,
              private msg_serv : MensajeService,
              private acc_serv : AccionesService,
              private menu_serv : MenuService,
              private tb_serv : TablesService) {}

  ngOnInit(): void {

    this.mod_serv.aplicacion = this.app_serv.get_aplicacion();
    this.acc_serv.aplicacion = this.app_serv.get_aplicacion();
    this.mod_serv.consultar_modulos().then(()=>{this.modulos = this.mod_serv.modulos;});
    this.target = document.querySelector('#btn_aceptar_acciones');
    
  }

  onSubmit() {
    alert('Thanks!');
  }

  /**
   * Funcion que se encarga de crear y actualizar un modulo.
   * @param ind_actualiza indicador de actualizacion del modulo.
   */
  crearModulo(ind_actualiza :boolean = false) {

    this.mod_serv.id_modulo = null;
    if (ind_actualiza){
      this.mod_serv.id_modulo = this.accionesForm.get('modulo').value;

      if (!this.mod_serv.id_modulo){
        this.msg_serv.ver_mensaje('Debe seleccionar el módulo a editar.', '', this.msg_serv.TIPO_ERROR);
        return;
      }
    }
    const dialogRef = this.dialog.open(ModuloComponent, {
      width: '400px',
    });

    
    dialogRef.afterClosed().subscribe(result => {
      this.modulos = this.mod_serv.modulos
    });

    this.mod_serv.dialog_ref = dialogRef;
  }
  
  /**
   * se encarga de consultar los menus de la aplicacion.
   */
  consultar_menus_acciones(){

    let tipo = this.accionesForm.get('tipo').value;
    let fk_modulo =this.accionesForm.get('modulo').value
    this.mod_serv.id_modulo = fk_modulo;
    let data = {}

    if (tipo == 1){
      data["app"] = this.acc_serv.aplicacion.id_aplicacion;

      if(fk_modulo){
        data['fk_modulo'] = fk_modulo;
      }

      this.menu_serv.consultar_menus(data)
          .then(
            ()=>{
              this.menu = this.menu_serv.menu;
              this.ver_tabla_acciones = false;

              if(this.ver_tree_menu){
                this.acc_serv.tree_menu.dataSource.data = this.menu;
              }
              this.ver_tree_menu = true;
            }
          );
    }else if(tipo == 2){
      let fk_modulo =this.accionesForm.get('modulo').value;
      this.params['app'] = this.app_serv.get_aplicacion().id_aplicacion;

      if (fk_modulo){
        this.params['fk_modulo'] = fk_modulo;
      }

      if (!this.ver_tabla_acciones){

        this.ver_tree_menu = false;
        this.ver_tabla_acciones = true;
      }else{
        this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params);
      }

    }

  }

  /**
   * Muestra el modal de crear acciones
   */
  crear_accion(){

    const dialogRef = this.dialog.open(EditarAccionComponent, {
      width: '400px',
    });

    this.ver_tabla_acciones = false;

    dialogRef.afterClosed()
             .subscribe(
               ()=>{
                 this.ver_tabla_acciones = true;
                 this.acc_serv.id_accion = null;
               }
             );

    this.acc_serv.dialog_ref = dialogRef;

  }

  /**
   * Se encarga de mostrar el modal para la edicion de una accion.
   */
  @HostListener('editar_accion')
  editar_app(){

    let id_accion = this.tb_serv.params_event.id_accion;
    this.acc_serv.id_accion = id_accion;

    this.crear_accion();    

  }
}
